<template>
  <div>
    <!-- VERRES -->
    <div class="component-container glasses" @click="showGlassOptions = !showGlassOptions" v-if="defaultGlassProduct">
      <div class="component__select" :class="{ open: showGlassOptions }" @focusout="handleFocusOut">
        <span class="component__select--name">
          <span class="name">{{ product ? product.name : 'Choisir un verre' }}</span>
          <RoundButton class="bordered button" width="18" image="ic-arrow-drop-down.svg" />
        </span>

        <span class="c-arrow-down" v-if="!showGlassOptions"></span>
        <span class="c-arrow-up" v-if="showGlassOptions"></span>
      </div>
      <ul class="component__select-options" v-if="showGlassOptions">
        <li
          class="select--option"
          v-for="option in otherGlassOptions"
          v-bind:key="option.id"
          @click="selectGlassOption(option)"
        >
          <label class="labelSelect">
            <input type="checkbox" :value="option" />
            <span class="name">{{ option.name }}</span>
          </label>
        </li>
      </ul>
    </div>

    <!-- TEINTES -->
    <div class="component-container" @click="showTintsOptions = !showTintsOptions" v-if="defaultTints">
      <div class="component__select" :class="{ open: showTintsOptions }" @focusout="handleFocusOut">
        <span class="component__select--name">
          <span class="name">{{ tint && tint.tint ? tint.tint.label.toUpperCase() : 'Choisir une teinte' }}</span>
          <RoundButton class="bordered button" width="18" image="ic-arrow-drop-down.svg" />
        </span>

        <span class="c-arrow-down" v-if="!showTintsOptions"></span>
        <span class="c-arrow-up" v-if="showTintsOptions"></span>
      </div>

      <ul class="component__select-options" v-if="showTintsOptions">
        <li
          class="select--option"
          v-for="option in otherTintsOptions"
          v-bind:key="option.tint.label"
          @click="selectTintsOption(option)"
        >
          <label class="labelSelect">
            <input type="checkbox" :value="option" />
            <span class="color" :style="{ backgroundColor: option.tint.color }"></span>
            <span class="name">{{ option.tint.label.toUpperCase() }}</span>
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import RoundButton from '@Components/Menus/RoundButton.vue';
export default {
  components: {
    RoundButton,
  },
  props: ['options', 'value'],
  data: () => ({
    product: {},
    tint: {},
    showGlassOptions: false,
    showTintsOptions: false,
  }),
  methods: {
    selectGlassOption(option) {
      this.product = option;
      this.tint = this.product && this.product.productTints ? this.product.productTints[0] : {};
      this.selectTintsOption(this.tint);
      this.$emit('input', option);
    },
    selectTintsOption(option) {
      this.tint = option;
      var color = option.tint.color;
      var glass = document.querySelector('.svgMask g');
      glass.style.fill = color;

      this.$emit('input', option);
    },
    handleFocusOut() {
      // this.showGlassOptions = false;
    },
    handleFocus() {
      this.showGlassOptions = true;
    },
  },
  mounted() {
    if (this.defaultGlassProduct) {
      this.product = this.defaultGlassProduct;
    }
    if (this.defaultTints) {
      this.tint = this.defaultTints;
      var color = this.defaultTints.color;
      var glass = document.querySelector('.svgMask g');
      glass.style.fill = color;
    }
  },
  computed: {
    otherGlassOptions() {
      return this.options; // .filter(product => product != this.product);
    },
    defaultGlassProduct() {
      var currentProduct = this.$store.getters.getProductByDemoId(this.$route.params.id);

      return this.options.includes(currentProduct) ? currentProduct : {};
    },
    defaultTints() {
      var currentProduct = this.$store.getters.getProductByDemoId(this.$route.params.id);

      if (this.options.includes(currentProduct)) {
        return currentProduct.productTints[0];
      }

      return {};
    },
    tints() {
      return this.product
        ? this.product.productTints
        : this.defaultGlassProduct
        ? this.defaultGlassProduct.productTints
        : [];
    },
    otherTintsOptions() {
      return this.tints; // .filter(tint => tint != this.tint);
    },
  },
};
</script>

<style scoped>
.component__select--name {
  font-size: 0.8rem;
  padding: 0 0 0 25px;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 4px 20px;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  transition: background-color 800ms;
  cursor: pointer;
}
.component__select .button {
  transform: rotateZ(180deg);
  transition: transform 300ms;
}
.component__select.open .button {
  transform: rotateZ(0deg);
}

.no-touchevents .component__select:hover {
  background-color: rgba(255, 255, 255, 1);
  transition: background-color 200ms;
}
.c-arrow-down {
  justify-self: end;
}

.name {
  font-size: 18px;
  color: black;
  letter-spacing: 0.5px;
  margin-left: 2px;
}
.component__select-options .name {
  font-size: 18px;
}
#glassesTintsSelect {
  display: flex;
}
.color {
  display: inline-block;
  width: 15px;
  height: 15px;
}
.component__select-options {
  cursor: pointer;
  background-color: white;
  margin: 0;
  position: absolute;
  bottom: 100%;
  text-align: center;
  width: 300px;
  padding: 0;
  padding-top: 15px;
}
.labelSelect {
  cursor: pointer;
}
.no-touchevents .labelSelect:hover::after {
  content: '';
  padding-top: 4px;
  display: block;
  margin: auto;
  width: 200px;
  widows: 100px;
  text-align: center;
  border-bottom: 2px solid #5ebeb3;
}
.select--option {
  margin-bottom: 10px;
  height: 35px;
  align-content: center;
  list-style: none;
}

.select--option:last-child {
  border-bottom: none;
}
.component-container {
  width: 300px;
}
.select--option:nth-child(2n) {
  background-color: #ffffff;
}

.select--option input {
  display: none;
}
</style>
